import React from 'react';

/** TODO replace this with MUI Divider component */
const Separator: React.FC = () => (
  <>
    <div className="separator" />
    <style jsx>{`
      .separator {
        width: 100%;
        height: 1px;
        background-color: #e6e6e6;
        margin-bottom: 12px;
      }
    `}</style>
  </>
);

export default Separator;
